import styled from "styled-components";
import { colors, font, radius } from "../../styles/theme/tokens";

// Колір розділу — щоб учень відчував ритм уроку
export const SECTION_COLORS = {
  "Warm-up": [colors.amberSoft, colors.amberDeep],
  Vocabulary: [colors.brandSoft, colors.brandDeep],
  Listening: ["#E0F2FE", "#0369A1"],
  Speaking: [colors.pinkSoft, "#C2185B"],
  Grammar: [colors.successSoft, colors.success],
  Game: [colors.amberSoft, colors.amberDeep],
  Review: [colors.brandSoft, colors.brandDeep],
  Homework: [colors.successSoft, colors.success],
};

const sectionColor = (section, i) => (SECTION_COLORS[section] || SECTION_COLORS.Vocabulary)[i];

export const Frame = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  overflow: hidden;
  font-family: ${font.text};
  color: ${colors.ink};
  background: ${colors.bg};
`;

export const Decor = styled.div`
  position: absolute;
  top: -160px;
  right: -120px;
  width: 420px;
  height: 420px;
  border-radius: 50%;
  background: radial-gradient(circle, ${colors.brandSoft} 0%, rgba(238, 237, 255, 0) 70%);
  pointer-events: none;
`;

export const Header = styled.header`
  position: relative;
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 24px;
  padding: 40px 56px 0;
`;

export const HeaderText = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  min-width: 0;
`;

export const Section = styled.span`
  align-self: flex-start;
  padding: 6px 14px;
  border-radius: ${radius.pill};
  font-size: 16px;
  font-weight: 800;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: ${(props) => sectionColor(props.$section, 1)};
  background: ${(props) => sectionColor(props.$section, 0)};
`;

export const Title = styled.h2`
  font-size: 44px;
  font-weight: 800;
  line-height: 1.1;
`;

export const Instruction = styled.p`
  font-size: 24px;
  font-weight: 600;
  color: ${colors.muted};
`;

export const HeaderTools = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  flex-shrink: 0;
`;

export const Body = styled.div`
  position: relative;
  flex: 1;
  min-height: 0;
  padding: 24px 56px 40px;
`;

export const Unknown = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 14px;
  height: 100%;
  text-align: center;

  b {
    font-size: 28px;
    font-weight: 800;
  }

  span {
    font-size: 20px;
    color: ${colors.muted};
  }

  button {
    padding: 12px 28px;
    border-radius: 999px;
    font-family: ${font.text};
    font-size: 18px;
    font-weight: 800;
    color: #FFFFFF;
    background: ${colors.brand};
    cursor: pointer;
  }
`;

export const Mascot = styled.img`
  position: absolute;
  top: 6px;
  right: 40px;
  z-index: 1;
  width: 150px;
  transform: rotate(12deg);
  filter: saturate(1.4) contrast(1.15) drop-shadow(0 6px 14px rgba(43, 39, 102, 0.18));
  pointer-events: none;
`;
